module.exports = __webpack_public_path__ + "img/fachwirt_background.7f73499b.jpg";